import { StandaloneSearchBoxAnalytics } from '@coveo/headless';

export interface ICoveoSearchConfig {
  organizationId: string;
  siteName: string;
  searchSource: string;
  standaloneSearch: boolean;
}

export interface ICoveoSearchPersonalizationField {
  name: string;
  value: string;
}

export interface IPersonalizedFieldMapperProps {
  displayName: string;
  fieldName: PersonalizedFieldNames;
  userObjPropName?: string[];
  coveoFieldName: string;
  advancedQuery: boolean;
  fieldType?: string;
  templateName?: string;
}

export enum PersonalizedFieldNames {
  omconfidential = 'omconfidential',
  selectedstatconfidential = 'selectedstatconfidential',
  usertype = 'usertype',
  role = 'role',
  tier = 'tier',
  states = 'states',
  site = 'site',
  source = 'source',
  products = 'products',
  componentguid = 'componentguid',
  concepts = 'concepts',
  contenttype = 'contenttype',
  effectivedate = 'effectivedate',
  archived = 'archived',
  publishdate = 'publishdate',
  headline = 'headline',
  searchdescription = 'searchdescription',
}

export enum SiteNames {
  plsite = 'now',
  pldemosite = 'nowdemo',
  obpldemosite = 'pldemo',
  obplsite = 'pl',
  blsite = 'lmbl',
  bldemosite = 'lmbldemo',
  obblsite = 'sc',
  obbldemosite = 'scdemo',
  news = 'news',
  newsdemo = 'newsdemo',
}

export interface ICoveoSiteConfig {
  siteName: string;
  search: {
    additionalSites: Array<string>;
    additionalSources: Array<string>;
  };
}

export interface IStandaloneSearchLocalStorage {
  value: string;
  analytics: StandaloneSearchBoxAnalytics;
}
